// @ts-nocheck
import React, { useCallback } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import ajaxService from "services/ajaxService";
import {
  extractTicketAssigneesFromResponse,
  mapTicketAssigneeListToSelectOptions,
  resolveTicketAssigneesHasMore,
  TICKET_ASSIGNEES_PER_PAGE,
} from "./ticketSaleAssignmentUtils";

const selectProps = {
  className: "basic-single w-100",
  classNamePrefix: "select2-selection",
};

const asyncModalMenuProps =
  typeof document !== "undefined"
    ? {
        menuPortalTarget: document.body,
        styles: {
          menuPortal: base => ({ ...base, zIndex: 2050 }),
        },
      }
    : {};

/**
 * Single multi-select for sale and sales_team assignees (search + infinite scroll).
 * Options label format: "{name} - {type}".
 */
const TicketSaleAssignmentFields = ({
  isDisabled = false,
  formValue,
  formErrors = {},
  onFieldChange,
}) => {
  const { t } = useTranslation("ticketManagement");

  const loadOptions = useCallback(async (searchQuery, _loadedOptions, additional) => {
    const page = additional?.page ?? 1;
    const keywords = String(searchQuery ?? "").trim();

    try {
      const response = await ajaxService.listTicketAssignees({
        page,
        per_page: TICKET_ASSIGNEES_PER_PAGE,
        ...(keywords !== "" ? { keywords } : {}),
      });
      const assignees = extractTicketAssigneesFromResponse(response);
      const options = mapTicketAssigneeListToSelectOptions(assignees);
      const hasMore = resolveTicketAssigneesHasMore(response, {
        page,
        perPage: TICKET_ASSIGNEES_PER_PAGE,
      });

      return {
        options,
        hasMore,
        additional: { page: page + 1 },
      };
    } catch {
      return {
        options: [],
        hasMore: false,
        additional: { page: 1 },
      };
    }
  }, []);

  return (
    <Row>
      <Col md={12}>
        <FormGroup className="mb-2">
          <Label>
            Sale &amp; Sale team <span className="text-danger">*</span>
          </Label>
          <AsyncPaginate
            {...selectProps}
            {...asyncModalMenuProps}
            isMulti
            debounceTimeout={500}
            isSearchable
            placeholder={t("saleAssignment.selectAssignees")}
            value={formValue?.assigneeSelections || []}
            onChange={data => onFieldChange("assigneeSelections", data || [])}
            loadOptions={loadOptions}
            additional={{ page: 1 }}
            closeMenuOnSelect
            isDisabled={isDisabled}
          />
          {formErrors.assigneeSelections ? (
            <small className="text-danger d-block mt-1">{formErrors.assigneeSelections}</small>
          ) : null}
        </FormGroup>
      </Col>
    </Row>
  );
};

export default TicketSaleAssignmentFields;
